import { collection, limit, or, orderBy, query, where } from "firebase/firestore";
import { ChatContent } from "../../components/Chat/ChatContent";
import { MessageSchema, nameofMessageSchemaCollection, nameofMessageSchemaReceiverId, nameofMessageSchemaSenderId, nameofMessageSchemaTimeStamp } from "../../firestore/Types/MessageSchema";
import { UserProfileView } from "../../firestore/Types/UserProfileSchema";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { VerifyLoggedIn } from "./VerifyLoggedIn";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { db } from "../../firebase/firebase";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { useCallback, useEffect, useState } from "react";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { useSearchParams } from "react-router-dom";
import { getProfilePictureURL } from "../../firebase/storage/ProfileFunctions";
import { getLoadingOpacity } from "../../components/Utils/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { readMessages } from "../../firestore/Functions/messageFunctions";

type UserProfileRow = UserProfileView & {
    notifications: boolean;
}

export function Messages() {
    const { currentUser } = useAuth();
    const [selectedUser, setSelectedUser] = useState<UserProfileView | null>(null);
    const [currentUserProfiles, setCurrentUserProfiles] = useState<UserProfileRow[]>([]);
    const messageRef = collection(db, nameofMessageSchemaCollection);
    const messageQuery = query(messageRef, or(where(nameofMessageSchemaSenderId, "==", currentUser?.uid), where(nameofMessageSchemaReceiverId, "==", currentUser?.uid)), orderBy(nameofMessageSchemaTimeStamp), limit(25));
    const [messages] = useCollectionData(messageQuery);
    const [showMessage, setShowMessage] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const userId = searchParams.get("userId");

    const { userProfiles } = useUtility();

    const handleSelectUser = (user: UserProfileView) => {
        setSelectedUser(user);
        setShowMessage(true)
    }
    
    const setupContext = useCallback(async (messages: MessageSchema[]) => {
        const tempCurrentUserProfiles = [] as UserProfileRow[];
        for (let i = messages.length - 1; i >= 0; i--) {
            const message = messages[i];
            let userId: string;
            if (message.SenderId === currentUser?.uid) {
                userId = message.ReceiverId;
            } else {
                userId = message.SenderId;
            }
            
            const userProfile = userProfiles.find(profile => profile.Id === userId);
            
            if (userProfile && tempCurrentUserProfiles.find(profile => profile?.Id === userProfile?.Id) === undefined) {
                tempCurrentUserProfiles.push({...userProfile, notifications: false});
            }
            
            if (message.IsRead === false && message.ReceiverId === currentUser?.uid) {
                tempCurrentUserProfiles.forEach(profile => {
                    if (profile.Id === userId) {
                        profile.notifications = true;
                    }
                });
            }
        };
        
        const searchParamUser = userProfiles.find(profile => profile.Id === userId);
        if (searchParamUser) {
            searchParams.delete("userId");
            setSearchParams(searchParams);
            setSelectedUser(searchParamUser);
            if (tempCurrentUserProfiles.find(profile => profile.Id === searchParamUser.Id) === undefined) {
                tempCurrentUserProfiles.push({...searchParamUser, notifications: false});
            }
        }
        setCurrentUserProfiles(tempCurrentUserProfiles);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser, userProfiles]);
    const resetInfo = function () {
        setShowMessage(false);
    }

    const framePicker = function () {
        if (!showMessage) {
            return <div className="grow overflow-y-auto">
                <div className="absolute-0 relative">
                <div className="flex flex-col grow gap-2">
                    {[...currentUserProfiles].map((profile, index) => <UserPRofileTag key={index} Profile={profile} isSelected={(profile.Id === selectedUser?.Id)} handleSelect={handleSelectUser} />)}
                    {currentUserProfiles.length === 0 && <div className="text-center">You currently have no messages</div>}
                </div>
            </div>
            </div>
                ;
        } else {
            return <div className="grow flex flex-col">
                <div className="flex flex-row p-2 border border-b-1 border-t-0 border-r-0 border-l-0">
                    <div className="back-button" onClick={resetInfo}></div>
                    <div className="grow text-center cal-header p-2">{selectedUser?.FirstName} {selectedUser?.LastName} - Conversation</div>
                </div>
                <ChatContent chatUserProfile={selectedUser ?? {} as UserProfileView} messages={messages as MessageSchema[] ?? []} />
            </div>
                ;
        }
    }
    useEffect(() => {
        if ((messages as MessageSchema[])?.find(message => message.ReceiverId === currentUser?.uid && message.SenderId === selectedUser?.Id && message.IsRead === false)) {
            readMessages(selectedUser?.Id ?? "");
        }
    }, [selectedUser, messages, currentUser]);

    useEffect(() => {
        setupContext(messages as MessageSchema[] ?? []);
    }, [messages, setupContext]);

    return (
        <LoggedInLayoutSelector>
            <VerifyLoggedIn />
            <div className="main-bg">
                <div className="section-box lg:mx-auto max-w-[950px] max-h-[calc(100vh-100px)] max-lg: min-h-[calc(100vh-100px)] flex flex-col">
                    {framePicker()}
                </div>
               
            </div>
        </LoggedInLayoutSelector>
    );
}

export function UserPRofileTag({ Profile, isSelected, handleSelect }: { Profile: UserProfileRow, isSelected: boolean, handleSelect: (profile: UserProfileView) => void }) {
    var bgColor = isSelected ? "bg-gray-200 " : " ";
    const [ImgSrc, setImgSrc] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        getProfilePictureURL(Profile.Id).then((url) => {
            setImgSrc(url);
            setIsLoading(false);
        });
    }, [Profile.Id]);
    return (
        <button onClick={() => handleSelect(Profile)} className="relative min-h-10">
            <div className={"flex flex-row justify-start items-center hover:bg-blue-200 rounded-lg " + bgColor + getLoadingOpacity(isLoading)} >
                {ImgSrc !== "" && <img src={ImgSrc} alt="profile" className="rounded-full w-[20%] max-w-10 m-4 aspect-square" />}
                <h3 className="text-sm font-semi">{Profile.FirstName} {Profile.LastName}{(Profile.notifications) &&<span> <FontAwesomeIcon icon={faBell} /></span>}</h3>
            </div>
            {isLoading && <FontAwesomeIcon icon={faSpinner} spin={true} fontSize="40px" color="gray" />}
        </button>
    );
}